import React from 'react';

import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import FeeTable from '../../FeeTable';

const defaultArray = [];

const DefaultSection = ({
  groups,
  items = defaultArray,
  cdSection,
  isNameAmountSection,
  amountColumnName,
  isNonBorrowerPaidFieldsIncluded,
  isFeeProviderColumnVisible,
  isNotEmptyCellsSection,
  isWithHeader,
  labelNameAmountSection,
  isTotalView,
  isLoading,
}) => {
  const data = groups || [{ items, isFeeProviderColumnVisible }];

  return (
    <>
      {data.map((group, index) => (
        <FeeTable
          amountColumnName={amountColumnName}
          cdSection={cdSection}
          isFeeProviderColumnVisible={group.isFeeProviderColumnVisible}
          isLoading={isLoading}
          isNameAmountSection={isNameAmountSection}
          isNonBorrowerPaidFieldsIncluded={isNonBorrowerPaidFieldsIncluded}
          isNotEmptyCellsSection={isNotEmptyCellsSection}
          isTotalView={isTotalView}
          isWithHeader={isWithHeader}
          items={group.items}
          key={index}
          labelNameAmountSection={labelNameAmountSection}
        />
      ))}
    </>
  );
};

DefaultSection.propTypes = {
  ...WithLoadingPropTypes,
  isNameAmountSection: PropTypes.bool.isRequired,
  isNotEmptyCellsSection: PropTypes.bool.isRequired,
  isTotalView: PropTypes.bool.isRequired,
  isNonBorrowerPaidFieldsIncluded: PropTypes.bool.isRequired,
  isWithHeader: PropTypes.bool.isRequired,
  cdSection: PropTypes.string,
  amountColumnName: PropTypes.string,
  isFeeProviderColumnVisible: PropTypes.bool,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.array,
      isFeeProviderColumnVisible: PropTypes.bool,
    }),
  ),
  items: PropTypes.array,
  labelNameAmountSection: PropTypes.string,
};

export default DefaultSection;
